import { useForm } from "react-hook-form";
import { useCallback } from "react";

export const usePermissionForm = () => {
  const { control, handleSubmit, reset } = useForm({
    defaultValues: { name: "", description: "" },
    mode: "onTouched",
  });

  const resetForm = useCallback(() => {
    reset({ name: "", description: "" });
  }, [reset]);

  const prefillForm = useCallback(
    (permission) => {
      reset({
        name: permission.name || "",
        description: permission.description || "",
      });
    },
    [reset],
  );

  return {
    control,
    handleSubmit,
    resetForm,
    prefillForm,
  };
};

export default usePermissionForm;
